import React, { useState } from 'react'

import { useDispatch, useStore } from 'react-redux'

import { FormattedRecipe } from '@library/menu-service/queries/menuApiRecipes/types'

import { actionTypes } from 'actions/actionTypes'
import { getCookieNameByDietType } from 'routes/Menu/hooks/useIsAddAProteinPaintedDoorEnabled'
import { getUserFirstName } from 'selectors/user'
import Cookies from 'utils/GoustoCookies'

import { RecipeCustomisationSection } from './RecipeCustomisationSection'
import { getCustomisationForRecipe } from './getCustomisationForRecipe'

export type IngredientCustomisationProps = {
  checked: boolean
  dietType: FormattedRecipe['attributes']['diet_type']
  onClick: () => void
  recipeId: string
}

const RecipeCustomisationContainer: React.FC<IngredientCustomisationProps> = ({
  checked,
  dietType,
  onClick,
  recipeId,
}) => {
  const customisation = getCustomisationForRecipe(dietType)
  const cookieName = getCookieNameByDietType(dietType)

  const store = useStore()
  const dispatch = useDispatch()
  const { basket } = store.getState()

  const [checkboxClicked, setCheckboxClicked] = useState<boolean>(false)
  const [timeoutId, setTimeoutId] = useState<number | null>(null)
  const [shouldShowConfirmationDialogue, setShouldShowConfirmationDialogue] =
    useState<boolean>(false)

  const firstName = getUserFirstName(store.getState())

  const setOrCancelTimeout = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      setTimeoutId(null)

      return
    }

    setTimeoutId(
      window.setTimeout(() => {
        setShouldShowConfirmationDialogue(true)
        dispatch({
          type: actionTypes.TRACKING,
          trackingData: {
            actionType: 'ui_interaction',
            element_name: 'add_protein',
            menuId: basket.get('currentMenuId'),
            orderId: basket.get('orderId'),
            proteinOption: customisation?.trackingSlug,
            recipeId,
          },
        })

        if (cookieName) {
          Cookies.set(cookieName, 1)
        }
      }, 2000),
    )
  }

  if (!customisation) {
    return null
  }

  return (
    <RecipeCustomisationSection
      checked={checked}
      customisation={customisation}
      firstName={firstName}
      onClick={onClick}
      checkboxClicked={checkboxClicked}
      setCheckboxClicked={setCheckboxClicked}
      setOrCancelTimeout={setOrCancelTimeout}
      shouldShowConfirmationDialogue={shouldShowConfirmationDialogue}
      recipeId={recipeId}
    />
  )
}

export { RecipeCustomisationContainer }
